import { Component, OnInit, Input } from '@angular/core';
import { ConfigSystemParams, WidgetTitles } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardStatisticSecondary } from 'src/app/core/interfaces/general/dashboard-statistic';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';

@Component({
  selector: 'app-stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss']
})
export class StatComponent implements OnInit {

  @Input() decimalPlaces   : number | undefined;
  @Input() icon            : string | undefined;
  @Input() iconColour      : string | undefined;
  @Input() link            : string | undefined;
  @Input() linkText        : string | undefined;
  @Input() loading         : boolean=true;
  @Input() percentage      : string | undefined;
  @Input() prefix          : string | undefined;
  @Input() profit          : string | undefined;
  @Input() profitUpIsGood  : boolean | undefined=true;
  @Input() secondaries     : DashboardStatisticSecondary[] | undefined;
  @Input() showProfit      : boolean=true;
  @Input() showSpinner     : boolean=true;
  @Input() subTitle        : string | undefined;
  @Input() title           : string | undefined;
  @Input() unit            : string | undefined;
  @Input() useCompactLayout: boolean=false;
  @Input() useCountUp      : boolean=true;
  @Input() value           : any    | undefined;

  get digitsInfo           () { const decimals=this.decimalPlaces ?? 0; return "1." + decimals + "-" + decimals; }
  get effectiveValue       () { return this.isGbUsageStat ? this.usageDisplayValue : this.value                ; }
  get hasPercentage        () { return this.percentage!=null && this.percentage!==""                           ; }
  get isGbUsageStat        () { return this.title==this.statTitleTotalUsage || this.unit==='GB'                ; }
  get usageDisplayUnitLabel() { return this.showUsageAsTb ? 'TB' : 'GB'                                        ; }

  get showUsageAsTb(): boolean {
    try {
      if (!this.tbDisplayEnabled || !this.isGbUsageStat || !this.isNumber(this.value))
        return false;

      return this.value>=this.USAGE_TB_THRESHOLD_GB;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  get usageDisplayValue(): any {
    try {
      if (this.showUsageAsTb)
        return this.value/this.USAGE_TB_THRESHOLD_GB;

      return this.value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return this.value;
    }
  }

  get tbDisplayEnabled() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardUsageDisplayTbEnabled, true); }

  private readonly USAGE_TB_THRESHOLD_GB: number=1024;

  public option: {}={};
  
  //#region Stat/Widget Titles
  
  public statTitleTotalCostsLicence         : string=WidgetTitles.totalCostsLicence;
  public statTitleTotalCostsLicenceNotInc   : string=WidgetTitles.totalCostsLicenceNotIncUsage;
  public statTitleTotalCostsUsage           : string=WidgetTitles.totalCostsUsage;
  public statTitleTotalCostsUsageAndLicence : string=WidgetTitles.totalCostsUsageAndLicence;
  public statTitleTotalCostsUsageCustomer   : string=WidgetTitles.totalCostsUsageCustomer;
  public statTitleTotalCostsUsageNotInc     : string=WidgetTitles.totalCostsUsageNotIncLicences;
  public statTitleTotalProfitUsage          : string=WidgetTitles.totalProfitUsage;
  public statTitleTotalPurchaseCostsUsage   : string=WidgetTitles.totalPurchaseCostsUsage;
  public statTitleTotalSimProfitLicencesCost: string=WidgetTitles.totalSimProfitLicencesCost;
  public statTitleTotalSimProfitSimBuyCosts : string=WidgetTitles.totalSimProfitSimBuyCosts;
  public statTitleTotalSimProfitTotalProfit : string=WidgetTitles.totalSimProfitTotalProfit;
  public statTitleTotalUsage                : string=WidgetTitles.totalUsage;
  
  //#endregion

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService
  ) { }

  ngOnInit(): void {
    try {
      this.option = {
        decimalPlaces: this.decimalPlaces,
        duration     : 2,
        startVal     : 0,
        useEasing    : true,
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public isNumber(value: any): boolean {
     return typeof value === 'number';
  }
}
